module.exports = __webpack_public_path__ + "img/SummaryBannerMobile.e16ba086.png";